
import axios from 'axios';

export default class AuthService {

    static async login(params) {
        return axios.post("/auth/login", params);
    }

    static async logout() {
        return axios.post("/auth/logout").then(() => {
            localStorage.removeItem('data');
        });
    }

    static async register(params) {
        return axios.post("/auth/register", params);
    }

    static async code_verification(params) {
        return axios.post("/auth/code_verification", params);
    }


}